import { MAX_EMAIL_LENGTH, MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from "@constants/validation";

export function isValidUrl(url: string) {
    const regex = /^(http|https):\/\/(([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,})(:[0-9]{1,4})?(\/[^\s]*)*$/;

    if (url.length > 2000) {
        return "URL too long.";
    }
    if (!/^http(s)?:\/\//.test(url)) {
        return "URL must start with 'http://' or 'https://'.";
    }
    if (!regex.test(url)) {
        return "Invalid URL.";
    }
    return "";
}

export function isValidEmail(email: string) {
    const emailRegex = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (email.length > MAX_EMAIL_LENGTH) {
        return "Email too long";
    }
    if (!emailRegex.test(email)) {
        return "Invalid email address.";
    }
    return "";
}

export function isValidPassword(password: string) {
    let error = false;

    if (password.length < MIN_PASSWORD_LENGTH) {
        return `Minimum ${MIN_PASSWORD_LENGTH} characters`;
    }

    if (password.length > MAX_PASSWORD_LENGTH) {
        return `Maximum ${MAX_PASSWORD_LENGTH} characters`;
    }

    // Check for uppercase letter
    if (!/[A-Z]/.test(password)) {
        error = true;
    }

    // Check for lowercase letter
    if (!/[a-z]/.test(password)) {
        error = true;
    }

    // Check for digit
    if (!/\d/.test(password)) {
        error = true;
    }

    // If there are any errors, return the combined error message
    if (error) {
        return "Password must contain at least one uppercase letter, one lower case letter and one digit.";
    }

    // Password is valid if all conditions are met
    return "";
}

export function isValidLetters(str: string) {
    const regex = /^[a-zA-Z]+$/;

    if (!regex.test(str)) {
        return "Only letters are allowed.";
    }

    return "";
}

export function isValidLettersAndSpaces(str: string) {
    const regex = /^[a-zA-Z\s]+$/;

    if (!regex.test(str)) {
        return "Only letters and spaces are allowed.";
    }

    return "";
}

export function isValidAlphanumeric(str: string) {
    const regex = /^[a-zA-Z0-9]+$/;

    if (!regex.test(str)) {
        return "Only letters and digits are allowed.";
    }

    return "";
}

export const isRequiredField = (val: string, fieldName: string) => {
    return val.trim() ? "" : `${fieldName} is required.`;
};

export const isValidPrice = (value: string) => {
    // Check if the value is a number and is greater than or equal to 0
    const price = parseFloat(value);

    // Ensure it's a valid number and a non-negative value
    if ((Number.isNaN(price)) || (price < 0)) {
        return "Price must be a valid, non-negative number.";
    }

    return ""; // Return an empty string if it's valid (no error)
};

export const isValidNumber = (value: number, min: number, max: number) => {
    if ((value < min) || (value > max)) {
        return `Value must be between ${min} and ${max}.`;
    }
    return "";
};

export function isValidHexColor(hex: string) {
    // Regular expression to match valid 3, 6, or 8 digit hex color codes
    const hexColorRegex = /^#([A-Fa-f0-9]{3}){1,2}([A-Fa-f0-9]{2})?$/;

    // Test the string against the regex
    if (!hexColorRegex.test(hex)) {
        return "Invalid hex colour";
    }

    return "";
}

export function isValidMaxLength(str: string, maxLength: number) {
    if (str.length > maxLength) {
        return `Maximum ${maxLength} characters.`;
    }
    return "";
}
